// extracted by mini-css-extract-plugin
export default {"card1":"Home_card1__YtZlB","smallCard1":"Home_smallCard1__ivw0D","smallCard2":"Home_smallCard2__X4aKg","smallCard3":"Home_smallCard3__vao2t","smallCard4":"Home_smallCard4__4dvRu"};